__turbopack_context__.v({
  "card-block-container": "AdDescription-module-scss-module__vVoRGW__card-block-container",
  "copy": "AdDescription-module-scss-module__vVoRGW__copy",
  "description": "AdDescription-module-scss-module__vVoRGW__description",
  "description-title": "AdDescription-module-scss-module__vVoRGW__description-title",
});
